module.exports = __webpack_public_path__ + "img/nextpay-logo.634bbedc.svg";